export default class InvalidCredentialsError extends Error {}
